import { inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import {
  AfterReloadMessage,
  AfterReloadMessagesNotifierService
} from "src/app/services/after-reload-messages-notifier.service";
import {
  TaskExecutionPlan,
  TasksService,
  TaskType
} from "src/app/services/tasks.service";
import { ToastService } from "src/app/services/toast.service";

@Injectable()
export class AfterReloadMessagesNotifierGuard implements CanActivate {
  private readonly afterReloadMessagesNotifiesService = inject(
    AfterReloadMessagesNotifierService
  );
  private readonly toastService = inject(ToastService);

  private readonly tasksService = inject(TasksService);

  async canActivate(): Promise<boolean> {
    const messages = await this.afterReloadMessagesNotifiesService.popAll();

    this.tasksService.schedule({
      plan: TaskExecutionPlan.WHEN_STABLE,
      type: TaskType.RUN_ONCE,
      fn: () => {
        messages.forEach((message: AfterReloadMessage) => {
          switch (message.type) {
            case "success": {
              this.toastService.success(message.message, {
                duration: 5000
              });
              break;
            }
            default: {
              this.toastService.info(message.message, {
                duration: 5000
              });
              break;
            }
          }
        });
      }
    });

    return true;
  }
}
